import React from 'react';

const Projects = () => (
  <div>
    <h2>Projects Page</h2>
    <p>This is where your projects will be listed.</p>
  </div>
);

export default Projects;